import React, { Component } from 'react'
import SectionHeader from './SectionHeader'
import Card3 from '../cards/Card3'
import HeadSvg from '../icons/HeadSvg';
import BoardSvg from '../icons/BoardSvg';
import TeamSvg from '../icons/TeamSvg';
import { Link } from 'react-router-dom';

export class WhyUsMp extends Component {
    render() {
        return (
            <div className='relative flex items-start gap-[20px] container pt-[72px] pb-[80px] max-[950px]:flex-col max-[950px]:w-full max-[950px]:gap-[32px] max-[400px]:pt-[42px]'>

                <div className='flex flex-col gap-[15px] w-1/2 max-[950px]:w-full'>
                    {/* <span className='text-[var(--orange)] text-[16px] font-[600]'>Why Choose Us</span> */}

                    <SectionHeader title="Niyə bizi seçməlisiniz" />

                    <p className='text-[16px] text-[#555] font-[400]'>
                        Biznesinizi rəqəmsal dünyada uğura daşıyacaq mükəmməl həllər axtarırsınız? Biz, texnologiyadakı ən son trendləri və yenilikləri bir araya gətirərək, sizin üçün ən yaxşı rəqəmsal həlləri təklif edirik. Sürətli, etibarlı və kreativ yanaşmamızla rəqiblərinizdən bir addım öndə olun.
                    </p>
                    <p className='text-[16px] text-[#555] font-[400]'>
                        Veb saytınızın dizaynı və funksionallığı uğurunuzun açarıdır. Komandamız, biznesinizi internetdə fərqləndirəcək unikal və istifadəçi dostu veb saytlar yaradır. SEO xidmətlərimizlə isə axtarış sistemlərində görünürlüğünüzü artıraraq daha çox müştəri əldə etməyə kömək edirik.
                    </p>

                    <Link to="/contact-us" className='mt-[10px]'>
                        <button className='bg-[#0E38B1] text-[#fff] text-[18px] font-[500] p-[14px_20px] rounded-[8px] flex items-center gap-[8px] max-[1001px]:text-[16px] max-[400px]:p-[10px_15px]'>
                            Elə indicə yığ
                        </button>
                    </Link>
                </div>

                <div className='relative flex justify-end items-start w-1/2 max-[950px]:w-[80%] max-[650px]:w-[90%] max-[480px]:w-[100%]'>
                    {/* Daire Arka Plan */}
                    <div className='absolute right-0 top-[-5px] h-[400px] w-[400px] rounded-full bg-[#78cbde] max-[440px]:w-[350px] max-[440px]:h-[350px] max-[390px]:w-[290px] max-[390px]:h-[290px] max-[330px]:w-[280px] max-[330px]:h-[280px] max-[310px]:w-[250px] max-[310px]:h-[250px]'></div>

                    {/* Kartlar */}
                    <div className='relative z-20   flex flex-col  gap-[14px] w-[75%] max-[1101px]:w-[85%] max-[650px]:w-[95%] max-[350px]:w-[100%] max-[350px]:gap-[10px] max-[310px]:gap-[5px]'>
                        <div className='flex justify-start max-[650px]:justify-center'>
                            <Card3
                                icon={<HeadSvg />}
                                className="shadow-lg max-[330px]:justify-center"
                                title="Yenilikçi Yanaşma"
                            />
                        </div>

                        <div className='flex justify-center max-[650px]:justify-end max-[330px]:justify-center'>
                            <Card3
                                icon={<BoardSvg />}
                                className="shadow-lg"
                                title="Uyğunlaşdırılmış Həllər"
                            />
                        </div>

                        <div className='flex justify-start max-[650px]:justify-center max-[330px]:justify-center'>
                            <Card3
                                icon={<TeamSvg />}
                                className="shadow-lg"
                                title="Effektiv İdarəetmə"
                            />
                        </div>



                    </div>
                </div>
            </div>
        )
    }
}

export default WhyUsMp;